import { CurrentUser } from './../../providers/currentUser'

export const EXISTING_USER_AUTHENTICATED = 'USER_TOOLBAR:ACTIONS:EXISTING_USER_AUTHENTICATED'
export const NEW_USER_AUTHENTICATED = 'USER_TOOLBAR:ACTIONS:NEW_USER_AUTHENTICATED'
export const USER_LOGOUT = 'USER_TOOLBAR:ACTIONS:LOGOUT'

/*
 * This is just a temporary workaround.
 * currently we have 2 navbars the old one is depend on the window.currentUser and the new one the localStorage["currentUser"]
 * So we want to "update" the old navbars that we've changed the currentUser
 * When we will rewrite the old navbars in Redux we will be able to fully migrate the currentUser to this store and wont have to update the localstorage here
 */
export const update = nextCurrentUser => {
  new CurrentUser().set(nextCurrentUser)
  window.location.reload()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/currentUser/currentUser.actions.js